{
  "feedback-emotion-page": {
    "text": {
      "title": "Ihr Feedback",
      "subtitle": "Bitte helfen Sie uns, unseren Service zu verbessern",
      "dissatisfied": "Unzufrieden",
      "on": "am",
      "neutral": "Neutral",
      "satisfaction-question": "Sind Sie mit unserem Service zufrieden?",
      "satisfied": "Zufrieden",
      "thanks": "Vielen Dank für Ihren Besuch",
      "tip": "Tipp: Klicken Sie auf das Gesichtssymbol, um zu zeigen, wie zufrieden Sie mit unserem Service sind"
    }
  }
}
